import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "article-categories" }
const _hoisted_3 = { class: "docs-listing docs-listing--articles" }

import { onBeforeMount, Raw, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { ArticlesView } from '@/models/doc.article'
import CategoriesSelection from '@/app/components/listing/categories/CategoriesSelection.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import vWait from 'vue-wait/src/components/v-wait.vue'
import { DocsTagsView } from '@/models/docs.tags'
import { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'Articles',
  setup(__props) {

const wait = useWait()

const articlesView = ref<Raw<ListView> | null>(null)
const tagsView = ref<Raw<DocsTagsView> | null>(null)

onBeforeMount(async () => {
  await loadArticles()
})

async function loadArticles(): Promise<void> {
  wait.start('Loading Articles')
  try {
    const response = await backend.getArticles()

    const articles = await ArticlesView.createView(response, true)
    articlesView.value = new ListView('All Articles', articles)

    tagsView.value = new DocsTagsView(response.tags, 'articles')
    wait.end('Loading Articles')
  } catch (error: any) {
    wait.start('Error Loading Articles')
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createBlock(Layout, { class: "layout--basic" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, {
        title: "Articles",
        hasDocSort: true
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(vWait, { for: "Error Loading Articles" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError)
          ]),
          _: 1
        }),
        _createVNode(vWait, {
          class: "layout__wrapper-inner layout__wrapper-inner--small-gap container",
          for: "Loading Articles"
        }, {
          waiting: _withCtx(() => [
            _createVNode(_component_loading_spinner)
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              (tagsView.value?.hasTags)
                ? (_openBlock(), _createBlock(CategoriesSelection, {
                    key: 0,
                    view: tagsView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_3, [
              _createVNode(ListDocs, { view: articlesView.value }, null, 8, ["view"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})